<template>
  <section v-if="!termoAceite">
    <div class="content">
      <Titulo
        title="Agenda"
        description="Selecione a data para consultar os horários disponíveis."
      />

      <div class="row align-items-center mt-4">
        <div class="dropdown dropdownFiltroAno col-md-auto" v-if="anosList">
          <button
            class="btn btn-light border dropdown-toggle w-100"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="text-muted pr-4">{{
              filtroAno ? filtroAno : "Ano"
            }}</span>
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" type="button" @click="setAno(null)">
              Todos
            </button>
            <button
              v-for="(ano, index) in anosList"
              :key="index"
              class="dropdown-item"
              type="button"
              @click="setAno(ano)"
            >
              {{ ano }}
            </button>
          </div>
        </div>
        <div
          class="dropdown dropdownFiltroMes col-md-auto mt-2 mt-md-0"
          v-if="anosList"
        >
          <button
            class="btn btn-light border dropdown-toggle w-100"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="text-muted pr-4">{{
              filtroMes !== null ? mesList[filtroMes] : "Mês"
            }}</span>
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" type="button" @click="setMes(null)">
              Todos
            </button>
            <button
              v-for="(mes, index) in mesList"
              :key="index"
              class="dropdown-item"
              type="button"
              @click="setMes(index)"
            >
              {{ mes }}
            </button>
          </div>
        </div>
      </div>
      <Calendario
        :list="diasDisponiveis"
        @click="selecionarAgenda"
        :idAgenda="idAgenda"
        :horarioSel="horarioSel"
        :tipoReserva="tipoReserva"
      />

      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            :link="`/produto/cdl-varejo-inteligente/formulario/reuniao/${idAgenda}`"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </div>
  </section>
  <section v-else>
    <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
    <Aceite
      :voltar="true"
      @fechar="cancelarAceite()"
      :actionVoltar="true"
      :action-aceite="true"
      @click="salvarAceite"
      :file="file"
      :aceite="aceite"
      :loading="loading"
      :strLoading="'Aguarde, salvando o termo'"
    />
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Aceite from "@/components/aceite/Aceite.vue";
import Calendario from "@/components/agenda/Calendario.vue";
export default {
  name: "CdlSaude",
  components: { Titulo, Botao, Aceite, Calendario },
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDL Varejo Inteligente",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente/produtos",
        },
        {
          nome: "Agenda",
          id: "agenda",
          produto: "CDL Varejo Inteligente",
        },
      ],
      termoAceite: false,
      aceite: "Estou de acordo com o termo acima.",
      file: null,
      loading: false,
      filtroAno: null,
      filtroMes: null,
      diasDisponiveis: [],
      idAgenda: null,
      dataSel: {
        dia: null,
        mes: null,
        ano: null,
      },
      horarioSel: {},
      tipoReserva: null,
    };
  },
  computed: {
    anosList() {
      const date = new Date();
      const listaAno = [];
      listaAno.push(date.getFullYear());
      date.setYear(date.getFullYear() + 1);
      listaAno.push(date.getFullYear());
      return listaAno;
    },
    mesList() {
      return this.$store.state.calendarOpts.pt.monthNames;
    },
    diasMes() {
      const year = this.filtroAno;
      const month = this.filtroMes;
      if (year !== null || month !== null) {
        var monthIndex = month;
        var names = ["dom", "seg", "ter", "qua", "qui", "sex", "sab"];
        var date = new Date(year, monthIndex, 1);
        var result = [];
        while (date.getMonth() == monthIndex) {
          result.push({
            dia: date.getDate(),
            diaSemana: names[date.getDay()],
            date:
              date.getFullYear() +
              "-" +
              ("0" + (date.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + date.getDate()).slice(-2),
          });
          date.setDate(date.getDate() + 1);
        }
        return result;
      }
      return [];
    },
  },
  mounted() {
    const date = new Date();
    this.filtroAno = date.getFullYear();
    this.filtroMes = date.getMonth();

    const session = JSON.parse(sessionStorage.getItem("reserva"));

    this.idAgenda = session.idAgenda;
    this.tipoReserva = session.tipoReserva;

    if (session.agenda) {
      let date = new Date(session.agenda.dia.date);
      this.dataSel = {
        dia: session.agenda.dia.dia,
        mes: date.getMonth(),
        ano: session.agenda.dia.ano,
      };
      this.setAno(session.agenda.dia.ano);
      this.setMes(date.getMonth());

      this.horarioSel = session.agenda.horarios;
    } else {
      this.setDiasDisponiveis();
    }
  },
  methods: {
    salvarAceite() {
      this.$router.push({ name: "pagamentoVarejo" });
    },
    cancelarAceite() {
      this.termoAceite = false;
    },
    setAno(ano) {
      this.filtroAno = ano;
      this.setDiasDisponiveis();
    },
    setMes(mes) {
      this.filtroMes = mes;
      this.setDiasDisponiveis();
    },
    setDiasDisponiveis() {
      const list = this.diasMes.map((dia) => {
        const date = new Date(dia.date + "T" + "23:59:59");
        const hoje = new Date();
        if (date.valueOf() < hoje.valueOf()) {
          dia.passado = true;
        }

        dia.ano = this.filtroAno;
        dia.mes = this.mesList[this.filtroMes];
        if (
          this.dataSel.ano === this.filtroAno &&
          this.dataSel.mes === this.filtroMes &&
          this.dataSel.dia === dia.dia
        ) {
          dia.sel = true;
        }
        return dia;
      });
      this.diasDisponiveis = list;
    },
    selecionarAgenda(props) {
      const session = JSON.parse(sessionStorage.getItem("reserva"));
      session.agenda = props;

      const dataInicio = props.dia.date + "T" + props.horarios.horaInicio;
      const dataFim = props.dia.date + "T" + props.horarios.horaFim;

      const dados = {
        agendaId: this.idAgenda,
        titulo: session.dadosReserva.evento,
        descricao: `Responsavel: ${session.dadosReserva.responsavel}, telefone: ${session.dadosReserva.telefone}`,
        nomeEvento: session.dadosReserva.evento,
        qtdPessoas: parseInt(session.dadosReserva.pessoas),
        aguaCafe: session.dadosReserva.aguacafe === "true",
        coffeExterno: session.dadosReserva.coffeexterno === "true",
        projetor: session.dadosReserva.projetor === "true",
        telao: session.dadosReserva.telao === "true",
        som: session.dadosReserva.som === "true",
        responsavel: session.dadosReserva.responsavel,
        telefone: session.dadosReserva.telefone,
        email: session.dadosReserva.email,
        inicio: dataInicio + ":00",
        fim: dataFim + ":00",
      };

      session.simularDados = dados;
      sessionStorage.setItem("reserva", JSON.stringify(session));
      this.$router.push({ name: "termoVarejo" });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>
